import { Grid } from "@mui/material";
import React from "react";
import { User, AppContext } from "../../../context/appContext";
import checkPermissionAdmin from "../../../functions/checkPermissionAdmin";
import FilterCheckboxes from "./filterCheckboxes";
import CoachSelect from "./coachSelect";
import FromTimeInput from "./fromTimeInput";
import TillTimeInput from "./tillTimeInput";
import StartSearchButton from "./startSearchButton";
import ExportExcelButton from "./exportExcelButton";

const SearchControlls = (): React.JSX.Element => {
  const {
    user,
  }: {
    user: User;
  } = React.useContext(AppContext);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
      }}
    >
      {/* show the input if the user is an admin */}
      {checkPermissionAdmin(user) && (
        <Grid item xs={12} md={6}>
          <CoachSelect />
        </Grid>
      )}

      <Grid item xs={12} sm={4} md={2}>
        <FromTimeInput />
      </Grid>

      <Grid item xs={12} sm={4} md={2}>
        <TillTimeInput />
      </Grid>

      <Grid item xs={12} sm={4} md={2}>
        <StartSearchButton />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <FilterCheckboxes />
        <ExportExcelButton />
      </Grid>
    </Grid>
  );
};

export default SearchControlls;
